import { useEffect, useState } from "react";
import { Icon, Label } from "semantic-ui-react";

import { FileDropdown } from "components";
import { CustomerNoteUserInfo } from "components/CustomerModal/components/CustomerNotes/components/CustomerNoteRow/components";
import "components/CustomerModal/components/CustomerNotes/components/CustomerNoteRow/CustomerNoteRow.scss";
import { DATE_FORMATS_FNS } from "components/DatePicker";
import { CUSTOMER_TYPES } from "models";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";
import type { CustomerNote } from "models";

type CustomerNoteRowProps = {
  t: TFunction;
  customerNote?: CustomerNote;
  isCustomerNoteModal?: boolean;
  customerType?: CUSTOMER_TYPES.Driver | CUSTOMER_TYPES.Owner | CUSTOMER_TYPES.Contractor;
  onSelectNote?: () => void;
};

export const CustomerNoteRow = ({ t, customerNote, isCustomerNoteModal = true, onSelectNote, customerType }: CustomerNoteRowProps) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false);

  useEffect(() => {
    if (customerNote) setIsTextExpanded(false);
  }, [customerNote]);

  const getCustomerType = () => {
    if (!customerType) return null;

    if (customerType === CUSTOMER_TYPES.Driver) return t("v8_driver", "Driver");
    if (customerType === CUSTOMER_TYPES.Owner) return t("v8_owner", "Owner");
    return t("v8_contractor", "Contractor");
  };

  return (
    <div className="CustomerNoteRow">
      <div className={`${isCustomerNoteModal ? "modal-container" : "appointment-notes-container"}`}>
        <div className="details-container">
          <div className="icon-btn-container">
            <div className={`customer-note-icon ${customerNote?.dms_nr ? "customer-dms-note" : ""}`}>
              <Icon className={`user solid fill ${isCustomerNoteModal ? "modal-note-icon" : "appointment-note-icon"}`} />
            </div>
            {!customerNote?.dms_nr && (
              <div className="customer-note-edit-btn" onClick={onSelectNote}>
                <Icon className={`pen to square ${isCustomerNoteModal ? "modal-note-edit-icon" : "appointment-note-edit-icon"}`} />
              </div>
            )}

            {customerType && (
              <div style={{ marginLeft: "10px" }}>
                <Label basic>{getCustomerType()}</Label>
              </div>
            )}
          </div>
          {customerNote?.attachments && customerNote.attachments.length > 0 && <FileDropdown files={customerNote.attachments} />}

          <div className={`customer-note-text ${!isTextExpanded && "ellipsis"}`} onClick={() => setIsTextExpanded(prev => !prev)}>
            {customerNote?.note}
          </div>

          {!!customerNote?.dms_nr && (
            <div className="CustomerNoteUserInfo">
              <span className="user-name">{`${t("v8_added_by", "Added by")} DMS ${t("v8_on", "on")} `}</span>
              {customerNote.created_on && <span>{formatDate(customerNote.created_on, DATE_FORMATS_FNS.dateMonthYearTime)}</span>}
            </div>
          )}

          {!customerNote?.dms_nr && (
            <CustomerNoteUserInfo
              t={t}
              user={customerNote?.created_by}
              createdOn={customerNote?.created_on}
              updatedBy={customerNote?.updated_by}
              updatedOn={customerNote?.updated_on}
              userId={customerNote?.updated_by_id || customerNote?.created_by_id || 0}
            />
          )}
        </div>
      </div>
    </div>
  );
};
